import type { TrackingFn } from '@change-corgi/core-react/tracking';

/** Widened past the usual scalars for `share_asset_offered_variations`/`_rendered`, which are lists of variation names. */
type SharePayload = Record<string, string | number | boolean | readonly string[] | undefined>;

function getTrackingCommonData() {
	return {
		location: 'instagram_stories',
	};
}

export function trackShare(eventName: string, trackingData: SharePayload | undefined, track: TrackingFn): void {
	void track(eventName, { ...getTrackingCommonData(), ...trackingData });
}

export function trackShareFailure(eventName: string, trackingData: SharePayload | undefined, track: TrackingFn): void {
	void track(eventName, { ...getTrackingCommonData(), ...trackingData });
}
